import { SxProps } from '@mui/material';

export const popperSx: SxProps = {
  '& .MuiClockNumber-root': {
    fontSize: '1.4rem',
  },
  '& .MuiCalendarPicker-root': {
    fontSize: '1.4rem',
  },
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '1.4rem',
  },
  '& .MuiPickersDay-dayWithMargin': {
    fontSize: '1.4rem',
  },
  '& .MuiTypography-root': {
    fontSize: '1.4rem',
  },
  '& .PrivatePickersFadeTransitionGroup-root': {
    fontSize: '1.4rem',
  },
  '& .MuiTimeClock-root': {
    fontSize: '1.4rem',
  },
  '@media (max-width: 767px)': {
    '& .MuiDateCalendar-root': {
      // size of the view minus double the width of the time picker (44px) and padding (16px)
      maxWidth: 'calc(100vw - 112px)',
    },
    '& .MuiMultiSectionDigitalClockSection-item': {
      width: '44px',
      margin: '0',
      padding: '0 4px',
    },
    '& .MuiMultiSectionDigitalClockSection-root': {
      width: '44px',
    },
  },
};
